"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PoolType = exports.SwapType = exports.QueryType = void 0;
var QueryType;
(function (QueryType) {
    QueryType[QueryType["SINGLE_ROUTE"] = 0] = "SINGLE_ROUTE";
    QueryType[QueryType["SPLIT_ROUTE"] = 1] = "SPLIT_ROUTE";
})(QueryType || (exports.QueryType = QueryType = {}));
var SwapType;
(function (SwapType) {
    SwapType[SwapType["INVALID"] = 0] = "INVALID";
    SwapType[SwapType["ADAPTER"] = 1] = "ADAPTER";
    SwapType[SwapType["DIRECT"] = 2] = "DIRECT";
})(SwapType || (exports.SwapType = SwapType = {}));
var PoolType;
(function (PoolType) {
    PoolType[PoolType["PANCAKE_V3"] = 1] = "PANCAKE_V3";
    PoolType[PoolType["UNISWAP_V3"] = 2] = "UNISWAP_V3";
    PoolType[PoolType["UNISWAP_V2"] = 3] = "UNISWAP_V2";
    PoolType[PoolType["AERODROME_V3"] = 4] = "AERODROME_V3";
    PoolType[PoolType["AERODROME_V2"] = 5] = "AERODROME_V2";
    PoolType[PoolType["SUSHISWAP_V3"] = 6] = "SUSHISWAP_V3";
    PoolType[PoolType["ALB_V3"] = 7] = "ALB_V3";
})(PoolType || (exports.PoolType = PoolType = {}));
